// extracted by mini-css-extract-plugin
export default {"wrapper":"Oba-z","play":"Pba-z"};